import { render } from "./Base-Timer.vue?vue&type=template&id=937a5ae8&scoped=true"
import script from "./Base-Timer.vue?vue&type=script&lang=js"
export * from "./Base-Timer.vue?vue&type=script&lang=js"

import "./Base-Timer.vue?vue&type=style&index=0&id=937a5ae8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937a5ae8"]])

export default __exports__